import { GetThematicsResponse, useGetThematicsMutation } from '@services';
import { useEffect, useState } from 'react';

export const useCauseriesListPageVM = () => {
    const [thematics, setThematics] = useState<GetThematicsResponse>([]);

    const [getThematics, { isLoading: isLoadingThematics, data, error: thematicsError }] = useGetThematicsMutation();

    useEffect(() => {
        getThematics(undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (data) {
            setThematics(data);
        }

        if (thematicsError) {
            console.error(thematicsError);
        }
    }, [isLoadingThematics, data, thematicsError]);

    return {
        thematics,
        isLoading: isLoadingThematics
    };
};
